import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import BodyClass from 'components/shared/body-class'
import userActions from 'actions/users/actions'
import isEmpty from 'lodash/isEmpty'
import PassportHeader from './passport-header'
import PassportProfile from './passport-profile'

const ClientPassport = ({ userId, subscription, fetchUserPassportSubscription }) => {
  useEffect(() => {
    fetchUserPassportSubscription(userId)
  }, [])

  const renderUnsubscribed = () => (
    <p className="text-sm font-normal">
      Not yet Signed up to Passport?
      <a href="/passport" className="text-primary-orange ml-1">
        Learn more.
      </a>
    </p>
  )

  return (
    <div className="client-passport">
      <BodyClass className="bg-secondary-lightgray" />
      <PassportHeader />
      <div className="my-5 w-full">
        <div className="flex md:flex-row flex-col flex-col-reverse justify-center container mx-auto">
          {isEmpty(subscription) ? renderUnsubscribed() : <PassportProfile subscription={subscription} /> }
        </div>
      </div>
    </div>
  )
}

ClientPassport.propTypes = {
  userId: PropTypes.number.isRequired,
  fetchUserPassportSubscription: PropTypes.func.isRequired,
  subscription: PropTypes.object,
}

const mapStateToProps = ({ user, auth }) => ({
  userId: auth.user.id,
  subscription: user.subscription,
})

const mapDispatchToProps = {
  fetchUserPassportSubscription: userActions.fetchUserPassportSubscription,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ClientPassport)
